import { render, staticRenderFns } from "./NotCanEdit.vue?vue&type=template&id=3a6d1ea1&scoped=true"
import script from "./NotCanEdit.vue?vue&type=script&lang=js"
export * from "./NotCanEdit.vue?vue&type=script&lang=js"
import style0 from "./NotCanEdit.vue?vue&type=style&index=0&id=3a6d1ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d1ea1",
  null
  
)

export default component.exports